<template>
  <v-form ref="ETABLISSEMENT_AFFILIATIONS" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="ETABLISSEMENT_AFFILIATIONS">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <etablissement-pole-emploi-affiliation v-if="isDisplayed('POLE_EMPLOI_AFFILIATION')"
                                               ref="POLE_EMPLOI_AFFILIATION"
                                               :theme="theme"
                                               :showMissing="showMissing"
                                               v-model:value=poleEmploiAffiliation
                                               @status=statusPoleEmploiAffiliation
                                               :over-ride-placeholder=placeholderPoleEmploiAffiliation
                                               :required="isRequired('POLE_EMPLOI_AFFILIATION')"
                                               :contextId=etablissement.id
                                               :readOnly="readOnly('POLE_EMPLOI_AFFILIATION')"
                                               :objType=objType
                                               :fiche=fiche
                                               :sectionName="sectionName">
        </etablissement-pole-emploi-affiliation>
        <etablissement-pole-emploi-adhesion v-if="isDisplayed('POLE_EMPLOI_ADHESION')"
                                            ref="POLE_EMPLOI_ADHESION"
                                            :theme="theme"
                                            :showMissing="showMissing"
                                            v-model:value=poleEmploiAdhesion
                                            @status=statusPoleEmploiAdhesion
                                            :over-ride-placeholder=placeholderPoleEmploiAdhesion
                                            :required="isRequired('POLE_EMPLOI_ADHESION')"
                                            :contextId=etablissement.id
                                            :readOnly="readOnly('POLE_EMPLOI_ADHESION')"
                                            :objType=objType
                                            :fiche=fiche
                                            :sectionName="sectionName">
        </etablissement-pole-emploi-adhesion>
        <etablissement-pole-emploi-identifiant v-if="isDisplayed('POLE_EMPLOI_IDENTIFIANT')"
                                               ref="POLE_EMPLOI_IDENTIFIANT"
                                               :theme="theme"
                                               :showMissing="showMissing"
                                               v-model:value=poleEmploiIdentifiant
                                               @status=statusPoleEmploiIdentifiant
                                               :over-ride-placeholder=placeholderPoleEmploiIdentifiant
                                               :required="isRequired('POLE_EMPLOI_IDENTIFIANT')"
                                               :contextId=etablissement.id
                                               :readOnly="readOnly('POLE_EMPLOI_IDENTIFIANT')"
                                               :objType=objType
                                               :fiche=fiche
                                               :sectionName="sectionName">
        </etablissement-pole-emploi-identifiant>
        <etablissement-statut-licence-spectacle v-if="isDisplayed('STATUT_LICENCE_SPECTACLE')"
                                                ref="STATUT_LICENCE_SPECTACLE"
                                                :theme="theme"
                                                :showMissing="showMissing"
                                                v-model:value=statutLicenceSpectacle
                                                @status=statusStatutLicenceSpectacle
                                                :over-ride-placeholder=placeholderStatutLicenceSpectacle
                                                :required="isRequired('STATUT_LICENCE_SPECTACLE')"
                                                :contextId=etablissement.id
                                                :readOnly="readOnly('STATUT_LICENCE_SPECTACLE')"
                                                :objType=objType
                                                :fiche=fiche
                                                :sectionName="sectionName">
        </etablissement-statut-licence-spectacle>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import CrudEtablissement from '@/generated/cruds/CrudEtablissement';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import { ObjTypes } from '@/generated/classes/ObjTypes';

  export default defineComponent({
    extends:  CrudEtablissement,
    components: {},
    props: {
      hideTitle: {
        type: Boolean,
      },
      isAbstract: {
        type: Boolean,
      },
    },

    data() {
      return {
        sectionName: Sections.ETABLISSEMENT_AFFILIATIONS,
        displayMap: new Map<string, Boolean>,
        readOnlyMap: new Map<string, Boolean>,
        requiredMap: new Map<string, Boolean>,
        placeholderPoleEmploiAffiliation: null,
        placeholderPoleEmploiAdhesion: null,
        placeholderPoleEmploiIdentifiant: null,
        placeholderStatutLicenceSpectacle: null,
      }
    },

    computed: {
      saveLabel () { 
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },

      errorTxt () { 
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },


      ressource () { return RessourceGenSection(GenSection.ETABLISSEMENT_AFFILIATIONS); },

      fields (): string[] {
        return ['POLE_EMPLOI_AFFILIATION', 'POLE_EMPLOI_ADHESION', 'POLE_EMPLOI_IDENTIFIANT', 'STATUT_LICENCE_SPECTACLE'];
      },

      extraButtons (): Button[] {
        return [];
      },

    },
    methods: {
      getRequiredAttributs(): string[] {
        const res: string[] = [];
        if (this.requiredAttributs) {
          this.requiredAttributs.forEach((attrib) => {
            const value = attrib.split(".");
            if (value[0] == this.sectionName) {
              res.push(value[1])
            }
          })
        }
        return res;
      },

      requiredMissing(requiredAttributs: string[], value: string): boolean {
        return requiredAttributs.length > 0 && requiredAttributs.includes(value);;
      },

      readOnly (value: string): boolean {
        let res = false;
        if (!this.editEtablissement.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("POLE_EMPLOI_AFFILIATION", false);
          this.readOnlyMap.set("POLE_EMPLOI_ADHESION", false);
          this.readOnlyMap.set("POLE_EMPLOI_IDENTIFIANT", false);
          this.readOnlyMap.set("STATUT_LICENCE_SPECTACLE", true);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("POLE_EMPLOI_AFFILIATION", true);
          this.displayMap.set("POLE_EMPLOI_ADHESION", true);
          this.displayMap.set("POLE_EMPLOI_IDENTIFIANT", true);
          this.displayMap.set("STATUT_LICENCE_SPECTACLE", this.requiredMissing(requiredAttributs, "STATUT_LICENCE_SPECTACLE") || !!this.fiche);
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },

      isRequired (value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
          this.requiredMap.set("POLE_EMPLOI_AFFILIATION", true);
          this.requiredMap.set("POLE_EMPLOI_ADHESION", true);
          this.requiredMap.set("POLE_EMPLOI_IDENTIFIANT", true);
          this.requiredMap.set("STATUT_LICENCE_SPECTACLE", this.requiredMissing(requiredAttributs, "STATUT_LICENCE_SPECTACLE") || !this.fiche);
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },

      picto (): string {
        return 'SectionPictoAffiliations' 
      },

      sectionSave (): void {
        return this.save();
      }
    }
  })
</script>
